/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'eye-blocked': {
    width: 35,
    height: 19,
    viewBox: '0 0 35 19',
    data: '<path pid="0" d="M10.898 10.902a6.533 6.533 0 01-.23-1.696 6.551 6.551 0 016.552-6.552c1.964 0 3.72.87 4.922 2.237l4.436-2.373C23.848 1.089 20.64 0 17.21 0 9.816 0 3.458 5.06.665 7.677a2.092 2.092 0 000 3.06c.993.93 2.44 2.17 4.22 3.38l6.013-3.215zM33.79 7.71A35.339 35.339 0 0029.543 4.3l-6 3.21c.145.54.229 1.108.229 1.695a6.551 6.551 0 01-6.552 6.552 6.531 6.531 0 01-4.922-2.236l-4.447 2.377c2.73 1.426 5.933 2.514 9.358 2.514 7.427 0 13.806-5.101 16.58-7.71a2.05 2.05 0 000-2.993h.001zM1.825 16.595L31.916.508l.7 1.31-30.09 16.086-.7-1.31z" _fill="#000"/><path pid="1" d="M14.211 9.131l4.619-2.469a3.009 3.009 0 00-4.618 2.469zM20.228 9.282l-4.617 2.468a3.009 3.009 0 004.617-2.469z" _fill="#000"/>'
  }
})
